import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function AdminRoute({ children, redirectTo = '/clients' }) {
  const { loading, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="p-4 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  if (!isAdmin()) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}
